import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./login.scss";
import { getApiInstance } from "../../utils/api";
import Input from "../../components/inputs/input/input";
import Button from "../../components/button/button";
import { IoLocationOutline } from "react-icons/io5";
import LogoAtlante from "../../assets/img/logo-atlante.png";

// Imágenes slider
import img1 from "../../assets/loginImg/bsk1.jpg";
import img2 from "../../assets/loginImg/bsk2.jpg";
import img3 from "../../assets/loginImg/bsk3.jpg";
import img4 from "../../assets/loginImg/bsk4.jpg";
import img5 from "../../assets/loginImg/bsk5.jpg";
import img6 from "../../assets/loginImg/bsk6.jpg";

const images = [img1, img2, img3, img4, img5, img6];
const labels = [
    "Bershka Barcelona",
    "Bershka Gran Vía, Madrid",
    "Bershka Berlín",
    "Bershka Berlín",
    "Bershka Londres",
    "Bershka Valencia",
];

const Login = ({ onLogin }) => {
    const isBershka = window.config?.isBershka;
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const [currentImage, setCurrentImage] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImage((prev) => (prev + 1) % images.length);
        }, 3000);
        return () => clearInterval(interval);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const api = getApiInstance();
        try {
            const response = await api.post("/api/Auth/login", {
                email: username,
                password: password,
            });

            const { token } = response.data;
            localStorage.setItem("token", token);
            onLogin(token);
            navigate("/mobiliario-central/todo");
        } catch (error) {
            setError(
                "Error al iniciar sesión. Por favor, verifica tus credenciales."
            );
        }
    };

    return (
        <div className={`login ${isBershka ? "" : "login__notBSK"}`}>
            {
                isBershka && (
                                <div className="login__left">
                <div className="login__left__carousel">
                    {images.map((img, index) => (
                        <div
                            key={index}
                            className={`login__left__image-container ${
                                index === currentImage ? "active" : ""
                            }`}
                        >
                            <img
                                src={img}
                                className="login__left__image"
                                alt={`Imagen ${index + 1}`}
                            />
                            <div className="login__left__label">
                                <span className="location-icon">
                                    <IoLocationOutline size={24} />
                                </span>
                                {labels[index]}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
                )
            }

            <div className="login__right">
                <h2 className="login__right__title">Iniciar Sesión</h2>
                <form className="login__right__form" onSubmit={handleSubmit}>
                    <Input
                        type="text"
                        label="Email"
                        name="email"
                        placeholder="Introduce tu email"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                    <Input
                        type="password"
                        label="Contraseña"
                        name="contraseña"
                        placeholder="Introduce tu contraseña"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <div className="login__right__form__button">
                        <Button
                            label="Iniciar sesión"
                            variant="filled"
                            type="submit"
                            fullWidth={true}
                        />
                    </div>
                    {error && (
                        <p className="login__right__form__error">{error}</p>
                    )}
                    <p className="login__right__form__info">
                        Si tienes problemas para iniciar sesión o si todavía no
                        tienes una cuenta, ponte en contacto con un
                        administrador.
                    </p>
                </form>
            </div>
        </div>
    );
};

export default Login;
